import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1920px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-content: center;
  background-color: var(--white);
  margin: 30px 0px 0px 0px;
  position: relative;

  // Formulario Title Container
  .formularioTitleContainer {
    width: 100%;
    max-width: 1270px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    flex-direction: row;
    z-index: 99;
  }

  // Title
  .formularioTitleContainer h2 {
    width: 100%;
    text-align: left;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2.25em;
    letter-spacing: -0.015em;
    margin: 0px 0px 40px 0px;
  }

  // Formulario
  form {
    width: 100%;
    max-width: 547px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 30px;
    background-color: var(--white);
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    border-radius: 12px;
  }

  // Inputs Container
  .inputContainer {
    min-width: 260px;
    max-width: 260px;
    margin: 0px 0px 20px 0px;
  }

  // Labels
  .inputContainer label {
    display: block;
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 13px;
    color: var(--black);
    margin: 0px 0px 6px 0px;
    display: flex;
    align-items: center;
    align-content: center;
  }

  .inputContainer label span {
    font-size: 18px;
    font-weight: 700;
    color: var(--orange);
  }

  // Input
  .inputContainer input,
  .inputContainer textarea {
    width: calc(100% - 32px);
    padding: 0px 15px 0px 15px;
    height: 29px;
    font-family: "Raleway", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 0.75em;
    color: var(--lightgray);
    border: 1px solid var(--lightgray);
    border-radius: 0;
    -webkit-appearance: none;
    box-shadow: 0;
    transition: 0.2s all;
    border-radius: 3px;
  }

  // Text Area
  .inputContainer textarea {
    min-width: calc(100% - 32px);
    max-width: calc(100% - 32px);
    height: 80px !important;
    max-height: 80px;
    min-height: 80px;
    padding: 15px 15px 15px 15px !important;
  }

  // Focus
  .inputContainer input:focus,
  .inputContainer textarea:focus {
    border: 1px solid var(--orange);
    outline: none;
  }

  // Input Mensaje
  #mensaje {
    width: 100%;
    max-width: none;
    min-width: none;
  }

  // ReCAPTCHA Container
  .reCaptchaContainer {
    width: 100% !important;
    margin: 5px 0px 0px 0px;
  }

  // Enviar Button
  #formButton {
    text-align: center;
    color: var(--white);
    border: 0px;
    background-color: var(--orange);
    cursor: pointer;
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    padding: 3px 30px 3px 30px;
    border-radius: 6px;
    margin: 20px 0px 0px 0px;
    transition: 0.2s all;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
  }

  #formButton span {
    font-size: 20px !important;
    margin: 5px 10px 0px 0px !important;
  }

  #formButton:hover {
    background-color: var(--lightorange);
  }

  // Botón Hover
  .formularioTitleContainer form button:hover {
    background-color: var(--lightorange);
  }

  // Ilustration Container
  .ilustrationContainer {
    width: 780px;
    min-width: 780px;
    margin-right: 36px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;
    position: absolute;
    right: 0;
  }

  // Ilustration
  .ilustrationContainer img {
    display: block;
    width: 100%;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Title
    .formularioTitleContainer h2 {
      font-size: 2em;
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    // Formulario Title Container
    .formularioTitleContainer {
      max-width: 1100px;
    }

    // Formulario
    form {
      max-width: 465px;
    }

    // Inputs Container
    .inputContainer {
      min-width: 220px;
      max-width: 220px;
      margin: 0px 0px 20px 0px;
    }
  }

  // 1550px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1550}) {
    // Ilustration Container
    .ilustrationContainer {
      width: 700px;
      min-width: 700px;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Title
    .formularioTitleContainer h2 {
      font-size: 1.9em;
    }

    // Formulario
    form {
      padding: 25px;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    // Formulario Title Container
    .formularioTitleContainer {
      max-width: 1000px;
    }

    // Inputs Container
    .inputContainer {
      margin: 0px 0px 15px 0px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    // Formulario Title Container
    .formularioTitleContainer {
      max-width: 850px;
    }

    // Formulario
    form {
      max-width: 400px;
    }

    // Inputs Container
    .inputContainer {
      min-width: 190px;
      max-width: 190px;
      margin: 0px 0px 15px 0px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    align-items: flex-start;
    align-content: flex-start;

    // Formulario Title Container
    .formularioTitleContainer {
      justify-content: center;
      width: 100%;
    }

    // Title
    .formularioTitleContainer h2 {
      width: 90%;
      text-align: center;
    }

    // Formulario
    form {
      margin: 245px 0px 0px 0px;
      max-width: 465px;
    }

    // Inputs Container
    .inputContainer {
      min-width: 220px;
      max-width: 220px;
    }

    // Ilustration
    .ilustrationContainer {
      top: 90px;
      width: 100%;
      max-width: 100%;
      min-width: 100%;
      margin: 0px 0px 0px 0px;
      display: flex;
      justify-content: center;
    }

    // Ilustration
    .ilustrationContainer img {
      width: 550px;
      margin: 0px 45px 0px 0px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    // Formulario
    form {
      max-width: 400px;
    }

    // Inputs Container
    .inputContainer {
      min-width: 190px;
      max-width: 190px;
    }
  }

  // 700px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet700}) {
    // Botón
    .formularioTitleContainer form button {
      width: 100%;
    }

    // ReCAPTCHA Container
    .reCaptchaContainer {
      display: flex;
      justify-content: center;
    }
  }

  // 525px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile525}) {
    // Formulario
    form {
      max-width: 75% !important;
    }

    // Inputs Container
    .inputContainer {
      min-width: 100%;
      max-width: 100%;
    }

    // Ilustration
    .ilustrationContainer {
      width: 100%;
      max-width: 100%;
      min-width: none !important;
    }

    // Ilustration
    .ilustrationContainer img {
      width: calc(100% - 30px);
      margin: 0px 30px 00px 0px;
    }
  }

  // 408px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile408}) {
    // Formulario
    form {
      margin: 160px 0px 0px 0px;
    }
  }
`;

export default Container;
